import {useEffect, useState, type RefObject} from 'react'

export function useFileTreeTooltip({
  focusRowRef,
  mouseRowRef,
}: {
  focusRowRef: RefObject<HTMLElement | null>
  mouseRowRef: RefObject<HTMLElement | null>
}) {
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const focusEl = focusRowRef.current
    const mouseEl = mouseRowRef.current

    if (!focusEl || !mouseEl) return

    const showIfOverflowing = () => {
      const contentRef: HTMLElement | null = focusEl.querySelector('.PRIVATE_TreeView-item-content-text')
      if (contentRef?.scrollWidth !== contentRef?.offsetWidth) {
        setShowTooltip(true)
      }
    }

    const handleFocus = () => showIfOverflowing()
    const handleBlur = () => setShowTooltip(false)
    const handleMouseEnter = () => showIfOverflowing()
    const handleMouseLeave = () => setShowTooltip(false)

    focusEl.addEventListener('focus', handleFocus)
    focusEl.addEventListener('blur', handleBlur)
    mouseEl.addEventListener('mouseenter', handleMouseEnter)
    mouseEl.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      focusEl.removeEventListener('focus', handleFocus)
      focusEl.removeEventListener('blur', handleBlur)
      mouseEl.removeEventListener('mouseenter', handleMouseEnter)
      mouseEl.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [focusRowRef, mouseRowRef])

  return showTooltip
}
